import buildRequestUrl from "lib/requests/requestUtils";
import athenaClient from "lib/axios/clients";
import _ from "lodash";
import getStatus from "lib/requests/status";

export const retrieveExpandedScenarioEstimationsByKey = async (
  filters,
  catalogList,
  retailersList,
  areasList,
  scenarioId
) => {
  const scenarioEstimationsconfig = {
    method: "GET",
    url: buildRequestUrl(
      {
        filters: {
          scenario_id: scenarioId,
          ...filters,
        },
      },
      "scenario_estimations"
    ),
  };

  const scenarioEstimations = await athenaClient(scenarioEstimationsconfig);
  const selectedScenarioEstimationsWithExpandedProperties = _.map(
    scenarioEstimations.data,
    (estimation) => {
      return {
        ...estimation,
        product: catalogList.products[estimation.product_id],
        retailer: retailersList[estimation.retailer_id],
        area: areasList[estimation.area_id],
      };
    }
  );

  const scenarioEstimationsByKey = _.keyBy(
    selectedScenarioEstimationsWithExpandedProperties,
    (estimation) =>
      `${estimation.product_id}-${estimation.area_id}-${estimation.retailer_id}`
  );

  return scenarioEstimationsByKey;
};

export const fetchScenarioTotalsForFilters = async (filters) => {
  const url = buildRequestUrl(
    {
      filters,
      expand: ["scenario"],
    },
    "scenario_totals_by_cycle"
  );

  const config = {
    method: "GET",
    url,
  };

  return athenaClient(config);
};

export const cloneScenario = async (data = {}) => {
  const config = {
    method: "POST",
    url: buildRequestUrl({}, "scenarios/clone"),
    data,
  };

  const response = await athenaClient(config);
  return response.data;
};

export const mapDataToScenario = async (data = {}) => {
  const config = {
    method: "POST",
    url: buildRequestUrl({}, "map_data_to_scenario"),
    data,
  };

  const response = await athenaClient(config);
  return response.data;
};

export const cloneTradePromotionAnnualScenario = async (data = {}) => {
  const config = {
    method: "POST",
    url: buildRequestUrl({}, "scenarios/clone"),
    data,
  };

  const response = await athenaClient(config);
  return response.data;
};

export const copyScenario = async (data = {}) => {
  const config = {
    method: "POST",
    url: buildRequestUrl({}, "scenarios/copyPrices"),
    data,
  };

  const response = await athenaClient(config);
  return response.data;
};

export const getScenarios = async (params) => {
  const config = {
    method: "GET",
    url: buildRequestUrl(params, "scenarios"),
  };

  const response = await athenaClient(config);
  return response.data;
};

export const getScenarioEstimations = async (params) => {
  const config = {
    method: "GET",
    url: buildRequestUrl(params, "scenario_estimations"),
  };

  const response = await athenaClient(config);
  return response.data;
};

export const getScenarioEstimationsByDate = async (params) => {
  const config = {
    method: "GET",
    url: buildRequestUrl(params, "scenario_estimations_by_date"),
  };

  const response = await athenaClient(config);
  return response.data;
};

export const getScenarioEstimationsDaily = async (params) => {
  const config = {
    method: "GET",
    url: buildRequestUrl(params, "scenario_estimations_daily"),
  };

  const response = await athenaClient(config);
  return response.data;
};

export const getScenarioTotalsByCycle = async (params) => {
  const config = {
    method: "GET",
    url: buildRequestUrl(params, "scenario_totals_by_cycle"),
  };

  const response = await athenaClient(config);
  return response.data;
};

export const getScenarioEstimationsCannibalized = async (data) => {
  const config = {
    method: "POST",
    url: buildRequestUrl({}, "scenarios/computeScenarioCrossAdjustments"),
    data,
  };
  const response = await athenaClient(config);
  const getResponse = await getStatus(response.data.task.id, () => {});

  return getResponse.task_info.result;
};
